export default __webpack_public_path__ + "static/media/image-study-admin-w.9951561d.png";